<div class="overlay">
    <div class="content">
        <div trans>
            <span trans>{{ message }}</span>
            &ngsp;
            <span trans [transValues]="{siteName: siteName}">
                Upgrade to get more out of :siteName.
            </span>
        </div>
        <a
            class="upgrade-button"
            mat-raised-button
            color="accent"
            routerLink="/billing/pricing"
            trans
            >Upgrade Now</a
        >
    </div>
    <svg-image name="upgrade"></svg-image>
</div>
